import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "components";
import { icons } from "utils/constants";
import { setShowSubscriptionPopup } from "store/globalSlice";
import { useNavigate } from "react-router-dom";
import "./SubscriptionPopup.scss";

const SubscriptionPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxData = useSelector((state) => state.global);
  const { showSubscriptionPopup, isDarkMode } = reduxData || {};

  return (
    <>
      {showSubscriptionPopup && (
        <Modal
          width="600px"
          title="Subscription"
          onHide={() => {
            dispatch(setShowSubscriptionPopup(false));
          }}
          isDarkMode={isDarkMode}
        >
          <div className="cps-26 cpe-26 cpt-26 cmb-10">
            <div className="h-175 cmb-40">
              <img src={isDarkMode ? icons.purSubLight : icons.purSub} alt="purSub" className="fit-image" />
            </div>
            <div className={`text-center text-18-600 ${isDarkMode ? "color-ffff" : "color-2749"}  cmb-40`}>
              Subscribe to create a project
            </div>
            <div className="f-center gap-3">
              <Button
                btnStyle="GD"
                btnText="Cancel"
                className="cps-45 cpe-45"
                onClick={() => {
                  dispatch(setShowSubscriptionPopup(false));
                }}
              />
              <Button
                btnStyle="PD"
                btnText="Buy Subscription"
                onClick={() => {
                  dispatch(setShowSubscriptionPopup(false));
                  navigate("/subscription");
                }}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SubscriptionPopup;
